/* unplugin-vue-components disabled */import { render } from "./CustomTable.vue?vue&type=template&id=6cdcbc9e"
const script = {}

import "./CustomTable.vue?vue&type=style&index=0&id=6cdcbc9e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__